import { join, filter } from 'lodash-es'

export const FormatClassNames = (...classNames) => {
  return join(filter(classNames), ' ')
}
